import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/home/Home.vue';
import About from '../views/about/About.vue';
import Contest from '../views/contests/Contests.vue';
import Publication from '../views/publications/Publications.vue';
import PublicationOpened01 from '../views/publications/PublicationOpened01.vue';
import PublicationOpened02 from '../views/publications/PublicationOpened02.vue';
import PublicationOpened03 from '../views/publications/PublicationOpened03.vue';
import PublicationOpened04 from '../views/publications/PublicationOpened04.vue';
import PublicationOpened05 from '../views/publications/PublicationOpened05.vue';
import Contact from '../views/contact/Contact.vue';
import FiscalRegistration from '../views/fiscals/FiscalRegistration.vue'; // Importando a nova view

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/atividades',
    redirect: '/'
  },
  {
    path: '/sobre',
    name: 'About',
    component: About
  },
  {
    path: '/concursos',
    name: 'Contest',
    component: Contest
  },
  {
    path: '/publicacoes',
    name: 'Publication',
    component: Publication
  },
  {
    path: '/publicacao/divida-ativa',
    name: 'PublicationOpened01',
    component: PublicationOpened01
  },
  {
    path: '/publicacao/plataforma-administracao-tributaria-digital',
    name: 'PublicationOpened02',
    component: PublicationOpened02
  },
  {
    path: '/publicacao/passo-a-passo-protocolar-recurso-icms',
    name: 'PublicationOpened03',
    component: PublicationOpened03
  },
  {
    path: '/publicacao/treinamento-sefisc-4.0',
    name: 'PublicationOpened04',
    component: PublicationOpened04
  },
  {
    path: '/publicacao/concurso-camara-caarapo',
    name: 'PublicationOpened05',
    component: PublicationOpened05
  },
  {
    path: '/contato',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/fiscais',
    name: 'FiscalRegistration',
    component: FiscalRegistration
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
